import './EmailSMSUnavailable.scss';
import React, { useMemo } from 'react';
import ImageChannelIntegrationNotSetup from 'assets/images/channel-integration-not-setup.svg';

const MAIN_CLASS = 'email-sms-unavailable';

type EmailSMSUnavailableProps = {
  type: 'email' | 'sms';
};

function EmailSMSUnavailable({ type }: EmailSMSUnavailableProps) {
  const info = useMemo(() => {
    if (type === 'sms') {
      return {
        title: 'Twilio integration not setup',
        subtitle: (
          <>
            Please head to project settings <b>SMS settings</b> to enable SMS on this tenant.
          </>
        ),
      };
    } else if (type === 'email') {
      return {
        title: 'Sendgrid integration not setup',
        subtitle: (
          <>
            Please head to project settings <b>Email settings</b> to enable email on this tenant.
          </>
        ),
      };
    } else {
      return { title: '', subtitle: '' };
    }
  }, [type]);

  return (
    <section className={MAIN_CLASS}>
      <img src={ImageChannelIntegrationNotSetup} alt={`${type} integration not setup`} />
      <article>
        <h2>{info.title}</h2>
        <p>{info.subtitle}</p>
      </article>
    </section>
  );
}

export default EmailSMSUnavailable;
